import formControl from "./formControl";

let emptyTypeArr = ["[]", "{}", null, undefined, ""];
export default {
  mixins: [formControl],
  props: {
    childMetaDataCodes: {
      type: Array,
      default() {
        return [];
      }
    },
    isOneToMany: {
      type: Boolean,
      default: true
    },
    //元数据等级，主表为0子表或者子表组件为1
    // metaDataLevel: {
    //   type: Number,
    //   default: 1
    // },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("sublist-meta-data");
      }
    },
    ignoreFields: {
      type: [Function, Array],
      default() {
        return [];
      }
    },
    redundanceFields: {
      type: Array,
      default() {
        return [];
      }
    },
    totalRowFieldKey: {
      type: String,
      default: ""
    },
    totalRowFieldTrueValue: {
      type: [String, Number],
      default: "1"
    },
    totalRowFieldFalseValue: {
      type: [String, Number],
      default: "0"
    },
    /**
     * 是否开启合计
     */
    openTotalRow: {
      type: Boolean,
      default: false
    },
    /**
     * 将行号同步给指定的字段
     */
    followIndexDataKey: {
      type: String,
      default: ""
    },
    /**
     * 当子表没有数据时候是否要强制加入一条数据
     */
    isLeastOne: {
      type: Boolean,
      default: true
    },
    /**
     * 当isLeastOne为true时候，子表自动创建的强制数据不为空数据时是否要入库
     */
    leastOneRowIsEmptyNotSave: {
      type: Boolean,
      default: true
    },
    /**
     * 合计结果是否要入库
     */
    //
    totlResultPost: {
      type: Boolean,
      default: false
    },
    //粘贴板处理
    clipboardDataHandler: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      emptyRowData: null,
      totalData: {
        $hash: "__total__" + dsf.uuid(),
        $ignoreValidate: true
      },
      virturlRowHash: dsf.global.$const.subTableEmptyRowHash
    };
  },
  computed: {
    $totalRowFieldKey() {
      if (!this.totalRowFieldKey) {
        return "";
      } else {
        return this.metadata_fullcode + "." + this.totalRowFieldKey;
      }
    },
    metadataDict() {
      let dict = this?.$vm?.metadataDict;
      if (dict) {
        let arr = {};
        let childMetadataDict = _.map(this?.childMetaDataCodes || [], (it) => {
          return { key: it, obj: dict[it] };
        });
        let result = {};
        _.each(childMetadataDict, (it) => {
          result[it.key] = it.obj;
        });
        return result;
      }
      return {};
    },
    $followIndexDataKey() {
      if (!this.isDesign && this?.childMetaDataCodes?.length > 0) {
        let key = _.find(this.childMetaDataCodes, (it) => {
          return this.followIndexDataKey === it || it.endsWith("." + this.followIndexDataKey);
        });
        return key;
      }
      return "";
    },
    $leastOneRowHash() {
      if (this.leastOneRowIsEmptyNotSave) {
        return this.virturlRowHash + dsf.uuid();
      } else {
        return dsf.uuid();
      }
    }
  },
  methods: {
    $clipboardDataHandler(data) {
      let rows = [];
      for (let i = 0; i < data.length; i++) {
        let d = data[i];
        let columns = [];
        let row = {};
        _.each(this.childMetaDataCodes, (key) => {
          let meta = this.metadataDict[key];
          if (meta.inColumn) {
            let column = _.find(columns, (col) => col.columnName == meta.inColumn);
            if (!column) {
              columns.push({
                columnName: meta?.inColumn,
                metadata: []
              });
              column = columns[columns.length - 1];
            }
            column.metadata.push(meta);
          }
        });
        if (columns.length) {
          for (let n = 0; n < columns.length; n++) {
            let col = columns[n];
            let meta = col?.metadata?.[0];
            if (meta) {
              row[meta.id] = d?.[n] || null;
            }
          }
        }
        rows.push(row);
      }
      return rows;
    },
    attachMustFieldToData(row) {
      if (!row) {
        return;
      }
      !("$editing" in row) && this.$set(row, "$editing", false);
      !("$hash" in row) && this.$set(row, "$hash", dsf.uuid());
      if (this.isUseRowButtons) {
        !("$buttons" in row) &&
          this.$set(row, "$buttons", dsf.mix(true, [], this.rowButtons || []));
      }
      this.$set(row, "$order", row.$index);
    },
    //为行数据设置配置的默认值
    setRowDefaultValue(row) {
      if (!this.isDesign && !this?.$vm) {
        return;
      }
      let result = this?.$vm?.$getSubTableRowDefault?.(this) || {};
      //检索行内数据是否设置过默认值
      if (dsf.isUnDef(result)) {
        return;
      }
      for (let k in result) {
        if (dsf.isUnDef(row[k])) {
          let defaultValue = this.getVmDefaultValue(k);
          this.$set(row, k, defaultValue);
        }
        // this.$set(row, k, undefined);
      }
    },
    //获取行数据字段配置的默认值
    getVmDefaultValue(key) {
      return this?.$vm?.$getDefaultValue?.(key) || undefined;
    },
    //更新行中随序号变化的字段
    updateIndexDataField(row, index) {
      if (this.isDesign || !this.$followIndexDataKey) {
        return;
      }
      this.$set(row, this.$followIndexDataKey, index);
    },
    //将汇总行数据总数据中剔除
    separateTotalRowFromValue(value) {
      if (
        !this.isDesign &&
        this.openTotalRow &&
        this.$totalRowFieldKey &&
        this.totalRowFieldTrueValue
      ) {
        let key = this.$totalRowFieldKey;
        this.$set(this.totalData, key, this.totalRowFieldTrueValue);
        let index = _.findIndex(value, (row) => row[key] == this.totalRowFieldTrueValue);
        if (index >= 0) {
          if (this?.value?.[index]?._id) {
            for (const key in this.value[index]) {
              this.$set(this.totalData, key, this.value[index][key]);
            }
          }
          this.value.splice(index, 1);
          return true;
        }
      }
      return false;
    },
    emitValueChange(v, data) {
      let eventArgs = { row: data || null, list: v };
      formControl.methods.$emitValueChange.call(this, v);
      this.$dispatch("value-mutation", eventArgs);
    },
    setEmptyRowData(row) {
      this.$nextTick(() => {
        row = row || this.value[0];
        this.emptyRowData = dsf.mix(true, {}, row);
      });
    },
    createLeastOneRow() {
      if (!this.isDesign && this.isLeastOne && !this.readOnly) {
        var value = null;
        if (!this.value) {
          value = [];
        } else {
          value = this.value;
        }
        if (value.length <= 0) {
          let row = {
            $hash: this.$leastOneRowHash,
            $index: 0
          };
          this.attachMustFieldToData(row);
          //检索行内数据是否设置过默认值
          this.setRowDefaultValue(row);
          this.updateIndexDataField(row, row.$index + 1);
          value.push(row);
        }
        this.emitValueChange(value);
        this.setEmptyRowData();
      }
    },
    rowHasChange(from, target) {
      let hasChanged = false;
      let baseType = ["string", "number", "boolean"];
      let key1 = Object.keys(from);
      let key2 = Object.keys(target);
      let key = _.uniq([...key1, ...key2]);

      for (let n = 0; n < key.length; n++) {
        let k = key[n];
        let v1 = from[k];
        let v2 = target[k];
        //将子组件有可能产生的空数据对比，这几种空数据可能是表单组件中产生的所以认为是一致的。
        if (emptyTypeArr.includes(v1) && emptyTypeArr.includes(v2)) {
          continue;
        }
        if (!dsf.isEqualObject(v1, v2)) {
          //两个数组之间比较
          if (dsf.isArray(v1) && dsf.isArray(v2)) {
            if (v1.length != v2.length) {
              hasChanged = true;
              break;
            } else {
              for (let i = 0; i < v1.length; i++) {
                let a1 = v1[i];
                let a2 = v2[i];
                if (this.rowHasChange(a1, a2)) {
                  hasChanged = true;
                  break;
                }
              }
              if (hasChanged) {
                break;
              }
            }
          }
          //两个对象比较
          else if (dsf.isObject(v1) && dsf.isObject(v2)) {
            if (this.rowHasChange(v1, v2)) {
              hasChanged = true;
              break;
            }
          } else {
            let type1 = dsf.type(v1);
            let type2 = dsf.type(v2);
            if (type1 == "null" || type1 == "undefined") {
              type1 = "empty";
            }
            if (type2 == "null" || type2 == "undefined") {
              type2 = "empty";
            }
            if (type1 == "empty" && type1 == type2) {
              continue;
            }
            //如果v1和v2仅仅是字符，数字，布尔的基本类型
            if (baseType.includes(type1) && baseType.includes(type2)) {
              //类型相同直接比较
              if (type1 == type2 && v1 !== v2) {
                hasChanged = true;
                break;
              }
              //如果其中一个是数字另一个是字符串，全部转字符再比较
              else if (
                (type1 == "string" && type2 == "number") ||
                (type1 == "number" && type2 == "string")
              ) {
                if (String(v1) !== String(v2)) {
                  hasChanged = true;
                  break;
                }
              }
              //如果类型不同
              else if (v1 !== v2) {
                hasChanged = true;
                break;
              }
            } else if (!dsf.isEmptyObject(v1) || !dsf.isEmptyObject(v2)) {
              //如果两个值任一一个为null另一个为对象，类如 {}和{key:{text:'',value:''}}的情况
              if (type1 == "empty" && dsf.isObject(v2)) {
                let value = Object.values(v2)
                  .filter((it) => dsf.isDef(it))
                  .join("");
                if (value) {
                  hasChanged = true;
                  break;
                }
              } else if (type2 == "empty" && dsf.isObject(v1)) {
                let value = Object.values(v1)
                  .filter((it) => dsf.isDef(it))
                  .join("");
                if (value) {
                  hasChanged = true;
                  break;
                }
              } else {
                hasChanged = true;
                break;
              }
            }
          }
        }
      }
      return hasChanged;
    },
    rowDataChange(row) {
      // 判断虚拟行是否因为用户操作发生了变化
      if (
        this.value.length == 1 &&
        row.$hash.startsWith(this.virturlRowHash) &&
        this.emptyRowData
      ) {
        let hasChanged = this.rowHasChange(this.emptyRowData, row);
        if (!hasChanged) {
          this?.$vm?.removeErrorsByRowHash?.(row.$hash);
        }
      }
    },
    //是否是个空行，与emptyRowData数据进行对比，如果与emptyRowData一致则表示数据没有变化
    isEmptyData(row) {
      if (!this.rowHasChange(this.emptyRowData, row)) {
        return true;
      }
      return false;
    }
  },
  design: {
    isMask: false,
    metadata: {
      isDeep: false,
      create(root) {
        if (!this.metadata) {
          this.metadata = {};
        }
        let childMetaData = [];
        let currCellSlot = "";
        dsf.designer.recursionLayoutTree(this, null, null, (child, parent, slot) => {
          if (child != this) {
            if (parent == this) {
              currCellSlot = slot;
            }
            let designOptions = child.$options.design || {};
            let metadataNode = designOptions.metadata || {};
            let result = metadataNode.create && metadataNode.create.call(child, root);
            if (result && result.metadata) {
              result.self = child;
              result.metadata.inColumn = currCellSlot;
              result && childMetaData.push(result);
              let isDeep = dsf.isDef(metadataNode.isDeep) ? metadataNode.isDeep : true;
              if (!isDeep) {
                return false;
              }
            }
          }
        });
        //冗余主表字段
        _.each(this.redundanceFields, (it) => {
          let el = document.querySelector("#des-" + it);
          if (el.__vue__) {
            let mainComponent = el.__vue__;
            let Component = Vue.extend(Vue.options.components[mainComponent.ctrlName]);
            let component = new Component();
            for (let key in mainComponent.$props) {
              if (dsf.isObject(mainComponent.$props[key])) {
                component[key] = dsf.mix(true, {}, mainComponent.$props[key]);
              } else if (dsf.isArray(mainComponent.$props[key])) {
                component[key] = dsf.mix(true, [], mainComponent.$props[key]);
              } else {
                component[key] = mainComponent.$props[key];
              }
            }
            component.caption = "main_" + mainComponent.caption;
            delete component.metadata.isFromMetaData;
            delete component.metadata.isuser;
            let designOptions = component.$options.design || {};
            let metadataNode = designOptions.metadata || {};
            let result = metadataNode.create && metadataNode.create.call(component, root);
            if (result && result.metadata) {
              // result = dsf.mix(true, {}, result);
              // result.self = dsf.mix(true, {}, component.$props);
              delete result.metadata.content;
              delete component.$props.metadata.content;
              result.metadata.inColumn = currCellSlot;
              result && childMetaData.push(result);
            }
          }
        });
        let exportRules = {};
        _.each(this.exportOptions, (v, k) => {
          if (v && v.length > 0) {
            exportRules[this.caption + "." + k] = v;
          }
        });
        return [
          {
            self: this,
            init: null,
            //可以导出列的配置
            export: {
              ...exportRules
            },
            metadata: this.metadata
          },
          ...childMetaData
        ];
      }
    },
    toMobile: {
      childComponentAddToMobileSubTable() {}
    }
  }
};
